<template>
    <div ref="container">
      <a-modal :title="title" :width="1200" :visible="visible" @ok="handleOk" @cancel="handleCancel" cancelText="关闭">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
            <a-form-model ref="form" :model="form" :rules="rules">
                <a-row class="form-row">
                    <a-col>
                        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="证照类型" prop="licenseType">
                          <a-select v-model="form.licenseType" class="code-mode-select" @change="onChange" placeholder="请选择证照类型">
                              <a-select-option
                                v-for="mode in modes"
                                :key="mode.value"
                                :value="mode.value">
                                {{ mode.label }}
                              </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col>
                        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="证照编码" prop="licenseCode">
                            <a-input placeholder="请输入证照编码" v-model="form.licenseCode" />
                        </a-form-model-item>
                    </a-col>
                    <a-col>
                        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有效期起" prop="expirationDate">
                            <JDate placeholder="请输入有效期起" v-model="form.expirationDate" ></JDate>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="24/1">
                        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有效期至" prop="expirationEndDate">
                            <JDate placeholder="请输入有效期至" v-model="form.expirationEndDate" ></JDate>
                        </a-form-model-item>
                    </a-col>
                    <!-- <a-col :span="24/1">
                        <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol" label="预警天数" prop="warningDays">
                            <a-input-number placeholder="1" v-model="form.warningDays" :min="1"></a-input-number>
                        </a-form-item>
                    </a-col> -->
                    <a-col :span="24/1">
                        <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
                            <a-textarea placeholder="请输入备注" :auto-size="{ minRows: 2, maxRows: 4 }" v-model="form.remark" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24/1">
                        <a-form-item  :labelCol="labelCol" :wrapperCol="wrapperCol" label="纸质文件编码" prop="paperCoding">
                            <a-input placeholder="请输入纸质文件编码" v-model="form.paperCoding" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24/1">
                        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                        <j-image-upload v-model="form.attachment" bizPath="material" text="上传" isMultiple></j-image-upload>
                        </a-form-model-item>
                    </a-col>
                </a-row>
          </a-form-model>
          
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JDate from '@/components/jeecg/JDate'
  import { ledgerAdd,ledgerEdit, licenseAdd, licenseEdit } from '@/api/api'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      JImageUpload,
      JDate
    },
    props:['productId','materialIds'],
    data() {
      return {
        title: '新增证照',
        visible: false,
        editId: '',
        fileList: [],
        model: {},
        materialIds:'',
        editingRow: null,
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
          md: { span: 5 },
          lg: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
          md: { span: 18 },
          lg: { span: 18 },
        },
        modes:[
          {
            value: 0,
            label: '经营许可证'
          },
          {
            value: 1,
            label: '生产许可证'
          },
          {
            value: 2,
            label: '产品注册证'
          }
        ],
        confirmLoading: false,
        materialId: '',
        form: {
          licenseType: 0,
          licenseCode: '',
          expirationDate: '',
          expirationEndDate: '',
          warningDays: '',
          remark: '',
          paperCoding: '',
          attachment: '',
          uuid: ''
        },
        uploadHeaders: {},
        action: window._CONFIG['domianURL'] + '/systemConfig/upload',
        rules: {
          licenseCode: [{ required: true, message: '编码不能为空!' }],
        },
        id: '',
      }
    },
    created() {},
    methods: {
      onChange(value, record) {
        console.log('直接获取value值', value)
        record.licenseType = value
      },
      add() {
        this.edit({})
      },
      initShow(e){
        this.visible  = true
        this.materialId = e.materialId
      },
      edit(record) {
        if (this.$refs.form !== undefined) this.$refs.form.resetFields()
        console.log(record,'=====================record==============')
        this.visible  = true
        this.form = record
        this.form.uuid = record.licenseId
        this.$nextTick(() => {})
        
      },
      handleChange({ file, fileList }) {
        console.log(file, 'file')
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            // if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
            let params = {
              materialId: this.materialId,
              licenseType: this.form.licenseType,
              licenseCode: this.form.licenseCode,
              expirationDate: this.form.expirationDate,
              expirationEndDate: this.form.expirationEndDate,
              warningDays: this.form.warningDays,
              remark: this.form.remark,
              paperCoding: this.form.paperCoding,
              attachment: this.form.attachment,
              materialId:this.materialIds
            }
            if (this.form.uuid) {
              // 编辑
              params.uuid = this.form.uuid
              const res = await licenseEdit(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.$refs.form.resetFields();
                this.close()
              } else {
                this.$message.error(res.data || res.errmsg)
              }
            } else {
              const res = await licenseAdd(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.$refs.form.resetFields();
                this.close()
              } else {
                this.$message.error(res.message)
              }
            }
          }
        })
      },
      handleCancel() {
        this.close()
      },
      validateSupplierName(rule, value, callback) {
        let params = {
          name: value,
          type: '供应商',
          id: this.model.id ? this.model.id : 0,
        }
        checkSupplier(params).then((res) => {
          if (res && res.code === 200) {
            if (!res.data.status) {
              callback()
            } else {
              callback('名称已经存在')
            }
          } else {
            callback(res.data)
          }
        })
      },
    },
  }
  </script>
  <style scoped>
    /* .productInfo {
      border: 1px solid #dedede;
      padding: 10px;  
    }
    .productInfo .title {
      font-size: 16px;
      border-left: 4px solid #1890FE;
      padding-left: 10px;
      margin: 0 10px;
    } */
  </style>